import {
    get
} from '../configApi'

export async function getDashboard() {
    return await get(`/report/dashboard/header`)
}

export async function getOverview(params) {
    return await get(`/report/dashboard/overview`, params)
}

export async function getTopreport(params) {
    return await get(`/report/dashboard/topreport`, params)
}

export async function getSumavg(params) {
    return await get(`/report/dashboard/reportdaily/sumavg`, params)
}

export async function getLibCourse(params) {
    return await get(`/report/dashboard/reportdaily/countLibCourse`, params)
}

export async function getViewCourse(params) {
    return await get(`/report/dashboard/reportdaily/countViewVideo`, params)
}

export async function getTicketExam(params) {
    return await get(`/report/dashboard/reportdaily/countTicketExam`, params)
}

export async function getViewLive(params) {
    return await get(`/report/dashboard/reportdaily/countViewLive`, params)
}
export async function getStudentRegister(params) {
    return await get(`/report/dashboard/reportdaily/countStudentRegister`, params)
}
export async function getStudentOnline(params) {
    return await get(`/report/dashboard/reportdaily/countStudentOnline`, params)
}

export async function getExcel(params) {
    return await get(`/report/dashboard/reportdaily/excel`, params)
}

export async function getTopreportTopbuy(params) {
    return await get(`/report/dashboard/topreport/topbuy`, params)
}

export async function getTopreportTopviewlive(params) {
    return await get(`/report/dashboard/topreport/topviewlive`, params)
}

export async function getTopreportTopuserview(params) {
    return await get(`/report/dashboard/topreport/topuserview`, params)
}

export async function getStudentReportUsergroup(params) {
    return await get(`/report/student/reportusergroup`, params)
}